import { scroll } from 'quasar';

/**
 * Scroll to the top of the closest given .
 * If no element is provided,
 *
 * @param el Target element for the internal closest call
 * @param selector Element selector for closest
 * @param x x coordinate
 * @param y y coordinate
 */
export default (el, selector = '.scroll', x = 0, y = 0) => {
  el = el || window;
  scroll.getScrollTarget(el, selector).scrollTo(x, y);
};
